<template>
  <div>

    <b-row>
      <b-col>
        <b-card title="">

          <b-table :items="items" :fields="fields" :busy="isBusy" stacked="md">
            <div slot="table-busy" class="text-center text-primary my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </b-table>



          <b-row>
            <b-col md="6" class="text-center text-md-left">
                <b-pagination
                  @change="getNotifications($event)"
                  v-model="currentPage"
                  :total-rows="rows"
                  :per-page="perPage"
                  aria-controls="my-table"
                ></b-pagination>
            </b-col>
            <b-col md="6 text-center text-md-right">
              {{ from +' to ' + to + ' of ' + total}}
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import notificationRepo from "@/api/repos/notificationRepo";

export default {
  mounted() {
    this.getNotifications(1);
    this.markNotificationsAsRead();
  },

  data() {
    return {
      isBusy: true,
      perPage: 12,
      currentPage: 1,
      from:0,
      to:0,
      total:0,
      rows: 12,
      fields: [
        { key: "data.message", label: "Message" },
        { key: "when", label: "When" },
        { key: "data.company", label: "Company", class:"text-md-right" },
      ],
      items: null
    };
  },

  methods: {
    async getNotifications(page) {
      this.isBusy = true;
      try {
        let { data } = await notificationRepo.notifications(page);
        this.items = data.notifications.data.map(x => {
          return { ...x, when: this.moment(x.created_at).fromNow() };
        });
        this.perPage = data.notifications.per_page;
        this.rows = data.notifications.total;
        this.currentPage = data.notifications.current_page;
        this.total = data.notifications.total;
        this.from = data.notifications.from;
        this.to = data.notifications.to;
      } catch (error) {
        console.log(error);
      } finally {
        this.isBusy = false;
      }
    },

    async markNotificationsAsRead() {
      this.notifications = [];
      try {
        await notificationRepo.update();
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>
